if ($("footer#footer").length) {
    if(!$('body').is('.in-index, .in-hodnoceni-obchodu, .in-kosik')){
        $('footer#footer').before($('footer#footer .reviewsWrap'))
    }
    $('.custom-footer__newsletter form input[type="email"]').attr("placeholder", "Váš e-mail...");
    $('.custom-footer__newsletter form button[type="submit"]').text("Odebírat");
    $(".newsletterWrap .newsletter").append($('.custom-footer__newsletter form'));
    $('footer#footer').before($('.newsletterWrap'));
    $('.newsletter').append('<span class="gdpr">Odesláním souhlasíte s <a href="/ochrana-osobnich-udaju/">ochranou osobních údajů.</a></span>');



    $("#signature a:first").prepend('<span>Běžíme na</span>');
    $("#signature a:eq(1)").text("Shoptet");
    $('#signature').append('<span>| Vytvořil <a href="https://www.shopcode.cz/?utm_source=kodovani&utm_medium=signature&utm_campaign=bes-petrovice" target="_blank" >Shopcode</a></span>');



    $(document).on("click", ".custom-footer > div .tls", function () {
        const parent = $(this).closest(".custom-footer > div");
        $(".custom-footer > div").not(parent).removeClass("open");
        parent.toggleClass("open");
    });


    $('footer#footer').before($('.instagramFeed'));

    $(".instagram-widget>a").each(function () {
        $(".instagramFeed .igFeed").append('<div class="igPost"><a href="' + $(this).attr("href") + '" target="_blank" style="background-image: url(' + $(this).find("img").attr("data-src") + ')"></a></div>')
    });




    $("footer#footer .contacts").append(
        $("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"),
    );

    $("footer#footer .contacts").append(
        $("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail")
    );

    $("footer#footer .contacts span.mail").append(`<span class="info">${mailInfo}</span>`)
    $("footer#footer .contacts span.tel").append(`<span class="info">${telefonInfo}</span>`)


    $("footer#footer .socials").append(
        $("footer#footer .contact-box li span.facebook").closest("li"),
    ); $("footer#footer .socials").append(
        $("footer#footer .contact-box li span.youtube").closest("li"),
    );
    $("footer#footer .socials").append(
        $("footer#footer .contact-box li span.instagram").closest("li"),
    );


}




